import { render, staticRenderFns } from "./TriggerBtnStandard.vue?vue&type=template&id=5f3c29af"
import script from "./TriggerBtnStandard.vue?vue&type=script&lang=js"
export * from "./TriggerBtnStandard.vue?vue&type=script&lang=js"
import style0 from "./TriggerBtnStandard.vue?vue&type=style&index=0&id=5f3c29af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports